export default {
  "app_label": "jobs",
  "model_name": "jobtype",
  "pagination": true,
  "columns": [
    {
      "name": "name",
      "label": "Name",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "str",
      "ellipsis": true,
      "search": true,
      "sort": true
    },
    {
      "name": "modified",
      "label": "Modified",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "datetime",
      "search": false,
      "sort": false
    }
  ],
  "filter_by": [
    {
      "label": "Grade",
      "name": "grade",
      "type": "api_reference",
      "api": {
        "url_name": "api:admin:jobs:jobgrade:autocomplete",
        "key": "pk",
        "display": "label",
        "pagination": true
      }
    }
  ],
  "export_import": null
}